// JS side of the §1.4 hardening: no context menu, no iOS pinch gesture, and a non-passive touchstart
// preventDefault on the input root (iOS magnifier / callout / double-tap zoom on the board).
export function installInputHardening(win: Window, inputRoot: HTMLElement): void {
  win.addEventListener('contextmenu', (e) => e.preventDefault());
  win.addEventListener('gesturestart', (e) => e.preventDefault());
  inputRoot.addEventListener('touchstart', (e) => e.preventDefault(), { passive: false });
}
